import { render, staticRenderFns } from "./SchwarztöneView.vue?vue&type=template&id=d2786e68&"
import script from "./SchwarztöneView.vue?vue&type=script&lang=js&"
export * from "./SchwarztöneView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports